/* eslint-disable max-lines */
import { CommLink, DetailedSensor, RfSensor, SpaceObjectType, ZoomValue } from '@ootk/src/main';
// TODO: Add the aperture size of telescopes as an optional parameter
export var Operators;
(function (Operators) {
    Operators["USSF"] = "USSF";
    Operators["USA"] = "US ARMY";
    Operators["RAF"] = "RAF";
    Operators["UKSA"] = "UKSA";
    Operators["RAAF"] = "RAAF";
    Operators["ESA"] = "ESA";
    Operators["ROC"] = "ROC";
    Operators["EISCAT"] = "EISCAT";
    Operators["RUSSF"] = "RUS SF";
    Operators["MIT"] = "MIT";
    Operators["NOR"] = "NOR";
    Operators["PLA"] = "PLA";
    Operators["CAS"] = "CAS";
    Operators["LEOLABS"] = "LEOLABS";
    Operators["CALTECH"] = "CALTECH";
    Operators["COMMERCIAL"] = "COMMERCIAL";
    Operators["ITAF"] = "ITAF";
    Operators["OWLNET"] = "OWL-Net";
})(Operators || (Operators = {}));
export const sensors = {
    CODSFS: new RfSensor({
        objName: 'CODSFS',
        shortName: 'COD',
        id: 0,
        name: 'Cape Cod SFS, Massachusetts',
        uiName: 'Cape Cod SFS',
        system: 'PAVE PAWS UEWR',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 41.754785,
        lon: -70.539151,
        alt: 0.060966,
        minAz: 347,
        maxAz: 227,
        boresightAz: [47, 227],
        minEl: 3,
        maxEl: 85,
        boresightEl: [20, 20],
        minRng: 200,
        maxRng: 5556,
        changeObjectInterval: 1000,
        beamwidth: 2.0, // National Research Council 1979. Radiation Intensity of the PAVE PAWS Radar System. Washington, DC: The National Academies Press.
        commLinks: [CommLink.AEHF, CommLink.WGS],
        zoom: ZoomValue.LEO,
        url: 'https://www.radartutorial.eu/19.kartei/01.oth/karte004.en.html',
        country: 'United States',
        operator: Operators.USSF,
        sensorId: 0, // For Testing Only
    }),
    BLEAFB: new RfSensor({
        objName: 'BLEAFB',
        shortName: 'BLE',
        id: 0,
        name: 'Beale AFB, California',
        uiName: 'Beale AFB',
        system: 'PAVE PAWS UEWR',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 39.136064,
        lon: -121.351237,
        alt: 0.112, // Open Street Maps
        minAz: 126,
        maxAz: 6,
        boresightAz: [186, 306],
        minEl: 3,
        maxEl: 85,
        boresightEl: [20, 20],
        minRng: 200,
        maxRng: 5556,
        changeObjectInterval: 1000,
        beamwidth: 2.0, // National Research Council 1979. Radiation Intensity of the PAVE PAWS Radar System. Washington, DC: The National Academies Press.
        commLinks: [CommLink.AEHF, CommLink.WGS],
        zoom: ZoomValue.LEO,
        country: 'United States',
        operator: Operators.USSF,
    }),
    CLRSFS: new RfSensor({
        objName: 'CLRSFS',
        shortName: 'CLR',
        id: 0,
        name: 'Clear SFS, Alaska',
        uiName: 'Clear SFS (UEWR)',
        system: 'PAVE PAWS UEWR',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 64.290556,
        lon: -149.186944,
        alt: 0.175, // Open Street Maps
        minAz: 184,
        maxAz: 64,
        boresightAz: [244, 4],
        minEl: 3,
        maxEl: 85,
        boresightEl: [20, 20],
        minRng: 200,
        maxRng: 5556,
        changeObjectInterval: 1000,
        beamwidth: 2.0, // National Research Council 1979. Radiation Intensity of the PAVE PAWS Radar System. Washington, DC: The National Academies Press.
        commLinks: [CommLink.AEHF, CommLink.WGS],
        zoom: ZoomValue.LEO,
        country: 'United States',
        operator: Operators.USSF,
    }),
    EGLAFB: new RfSensor({
        objName: 'EGLAFB',
        shortName: 'EGL',
        id: 0,
        name: 'Eglin AFB, Florida',
        uiName: 'Eglin AFB',
        system: 'AN/FPS-85',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 30.572411,
        lon: -86.214836,
        alt: 0.039, // Open Street Maps
        minAz: 120,
        maxAz: 240,
        boresightAz: [180],
        minEl: 3, // Should this be 0 for "horizon"?
        // TODO: Incorporate boresight into rae2ecf calculations for inclined sensors
        maxEl: 90, // https://en.wikipedia.org/wiki/Eglin_AFB_Site_C-6 (an elevation range from the horizon to 15° past the zenith)
        // maxEl: <Degrees>105, // https://en.wikipedia.org/wiki/Eglin_AFB_Site_C-6 (an elevation range from the horizon to 15° past the zenith)
        boresightEl: [45],
        minRng: 200,
        maxRng: 50000,
        changeObjectInterval: 1000,
        zoom: ZoomValue.GEO,
        beamwidth: 1.1, // Tmx 1.4 and Rcv 0.8 for Avg of 1.1
        url: 'https://www.radartutorial.eu/19.kartei/01.oth/karte002.en.html',
        country: 'United States',
        operator: Operators.USSF,
    }),
    RAFFYL: new RfSensor({
        objName: 'RAFFYL',
        shortName: 'FYL',
        id: 0,
        name: 'RAF Fylingdales, United Kingdom',
        uiName: 'RAF Fylingdales',
        system: 'BMEWS UEWR',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 54.361758,
        lon: -0.670051,
        alt: 0.26, // Open Street Maps
        minAz: 0,
        maxAz: 360,
        minEl: 3,
        maxEl: 85,
        minRng: 200,
        maxRng: 5556,
        changeObjectInterval: 1000,
        beamwidth: 2.0, // National Research Council 1979. Radiation Intensity of the PAVE PAWS Radar System. Washington, DC: The National Academies Press.
        commLinks: [CommLink.AEHF, CommLink.WGS],
        boresightAz: [0],
        boresightEl: [20],
        zoom: ZoomValue.LEO,
        country: 'United Kingdom',
        operator: Operators.RAF,
    }),
    CAVSFS: new RfSensor({
        objName: 'CAVSFS',
        shortName: 'CAV',
        id: 0,
        name: 'Cavalier SFS, North Dakota',
        uiName: 'Cavalier SFS',
        system: 'PARCS',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 48.724567,
        lon: -97.899755,
        alt: 0.352, // Open Street Maps
        minAz: 298,
        maxAz: 78,
        boresightAz: [8],
        minEl: 1.9,
        maxEl: 90,
        /*
         * TODO: incorporate boresight into rae2ecf calculations for inclined sensors
         * maxEl: <Degrees>95,
         */
        boresightEl: [25], // https://satelliteobservation.files.wordpress.com/2018/11/missile-warning-systems.pdf
        minRng: 200,
        maxRng: 3300, // 1,780 Nm http://www.fortwiki.com/Cavalier_Air_Force_Station
        changeObjectInterval: 1000,
        beamwidth: 1.2, // National Research Council 1979. Radiation Intensity of the PAVE PAWS Radar System. Washington, DC: The National Academies Press.
        commLinks: [CommLink.AEHF],
        zoom: ZoomValue.LEO,
        url: 'https://mostlymissiledefense.com/2012/04/12/parcs-cavalier-radar-april-12-2012/',
        country: 'United States',
        volume: true,
        operator: Operators.USSF,
    }),
    PITSB: new RfSensor({
        objName: 'PITSB',
        shortName: 'THL',
        id: 0,
        name: 'Pituffik SB, Greenland',
        uiName: 'Pituffik SB',
        system: 'BMEWS UEWR',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 76.570322,
        lon: -68.299211,
        alt: 0.392, // Open Street Maps
        minAz: 297,
        maxAz: 177,
        boresightAz: [357, 117],
        minEl: 3,
        maxEl: 85,
        boresightEl: [20, 20],
        minRng: 200,
        maxRng: 5556,
        changeObjectInterval: 1000,
        beamwidth: 2.0, // National Research Council 1979. Radiation Intensity of the PAVE PAWS Radar System. Washington, DC: The National Academies Press.
        commLinks: [CommLink.AEHF, CommLink.WGS],
        zoom: ZoomValue.LEO,
        url: 'https://www.radartutorial.eu/19.kartei/01.oth/karte004.en.html',
        country: 'United States',
        operator: Operators.USSF,
    }),
    COBRADANE: new RfSensor({
        objName: 'COBRADANE',
        shortName: 'CDN',
        id: 0,
        name: 'Eareckson Air Station, Alaska',
        uiName: 'Eareckson AFS',
        system: 'COBRA DANE',
        freqBand: 'L-Band',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 52.737,
        lon: 174.092,
        alt: 0.066, // Open Street Maps
        // boresight 319az https://mostlymissiledefense.com/2012/04/12/cobra-dane-radar-april-12-2012/
        minAz: 259, // https://www.radartutorial.eu/19.kartei/01.oth/karte003.en.html
        maxAz: 19,
        boresightAz: [319],
        minEl: 2,
        maxEl: 30,
        boresightEl: [20], // https://mostlymissiledefense.com/2012/04/12/cobra-dane-radar-april-12-2012/
        minRng: 200,
        maxRng: 14000, // https://mostlymissiledefense.com/2012/04/12/cobra-dane-radar-april-12-2012/
        minAz2: 251,
        maxAz2: 27,
        minEl2: 30,
        maxEl2: 80,
        minRng2: 200,
        maxRng2: 14000,
        changeObjectInterval: 1000,
        beamwidth: 0.6, // https://www.radartutorial.eu/19.kartei/01.oth/karte003.en.html
        commLinks: [CommLink.WGS],
        zoom: ZoomValue.LEO,
        url: 'https://www.radartutorial.eu/19.kartei/01.oth/karte004.en.html',
        country: 'United States',
        volume: true,
        operator: Operators.USSF,
    }),
    KWAJALT: new DetailedSensor({
        objName: 'KWAJALT',
        shortName: 'ALT',
        id: 0,
        name: 'ALTAIR, Kwajalein Atoll',
        uiName: 'Kwajalein Atoll (ALT)',
        system: 'ALTAIR',
        freqBand: 'VHF/UHF',
        type: SpaceObjectType.MECHANICAL,
        lat: 8.716667,
        lon: 167.733333,
        alt: 0,
        minAz: 0,
        maxAz: 360,
        minEl: 1,
        maxEl: 90,
        minRng: 200,
        maxRng: 50000,
        changeObjectInterval: 20000,
        commLinks: [CommLink.AEHF, CommLink.WGS],
        zoom: ZoomValue.GEO,
        url: 'https://www.radartutorial.eu/19.kartei/01.oth/karte005.en.html',
        country: 'United States',
        operator: Operators.USA,
    }),
    KWAJGBRP: new DetailedSensor({
        objName: 'KWAJGBRP',
        id: 0,
        name: 'Ground-Based Radar Prototype (GBR-P), Kwajalein Atoll',
        uiName: 'Kwajalein Atoll (GBR-P)',
        system: 'GBR-P',
        freqBand: 'X-Band',
        type: SpaceObjectType.MECHANICAL,
        lat: 8.716668,
        lon: 167.773334,
        alt: 0,
        minAz: 0,
        maxAz: 360,
        minEl: 1,
        maxEl: 90,
        minRng: 200,
        maxRng: 50000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'United States',
        operator: Operators.USA,
    }),
    KWAJMMW: new DetailedSensor({
        objName: 'KWAJMMW',
        id: 0,
        name: 'Millimeter Wave Radar, Kwajalein Atoll',
        uiName: 'Kwajalein Atoll (MMW)',
        system: 'Millimeter Wave Radar',
        type: SpaceObjectType.MECHANICAL,
        lat: 8.756668,
        lon: 167.773334,
        alt: 0,
        minAz: 0,
        maxAz: 360,
        minEl: 1,
        maxEl: 90,
        minRng: 0,
        maxRng: 50000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'United States',
        operator: Operators.USA,
    }),
    KWAJALC: new DetailedSensor({
        objName: 'KWAJALC',
        id: 0,
        name: 'ALCOR Radar, Kwajalein Atoll',
        uiName: 'Kwajalein Atoll (ALCOR)',
        system: 'ALCOR',
        freqBand: 'C-Band',
        type: SpaceObjectType.MECHANICAL,
        lat: 8.716668,
        lon: 167.773334,
        alt: 0,
        minAz: 0,
        maxAz: 360,
        minEl: 1,
        maxEl: 90,
        minRng: 0,
        maxRng: 50000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'United States',
        operator: Operators.USA,
    }),
    KWAJTDX: new DetailedSensor({
        objName: 'KWAJTDX',
        id: 0,
        name: 'TRADEX Radar, Kwajalein Atoll',
        uiName: 'Kwajalein Atoll (TDX)',
        system: 'TRADEX',
        type: SpaceObjectType.MECHANICAL,
        lat: 8.756668,
        lon: 167.733334,
        alt: 0,
        minAz: 0,
        maxAz: 360,
        minEl: 1,
        maxEl: 90,
        minRng: 0,
        maxRng: 50000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'United States',
        operator: Operators.USA,
    }),
    KWAJSPF: new DetailedSensor({
        objName: 'KWAJSPF',
        shortName: 'SF',
        id: 0,
        name: 'Space Fence, Kwajalein Atoll',
        uiName: 'Kwajalein Atoll (SF)',
        system: 'Space Fence',
        freqBand: 'S-Band',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 8.723, // SDC7-paper1014.pdf
        lon: 167.719,
        alt: 0.007,
        minAz: 268, // TODO This needs a better system (same as LEO Labs)
        maxAz: 272,
        minEl: 5, // ??
        maxEl: 175, // ??
        minRng: 50,
        maxRng: 3057.754, // https://www.spaceforce.mil/News/Article/2142648/swinging-for-the-space-fence/
        zoom: ZoomValue.LEO,
        volume: true,
        changeObjectInterval: 2000,
        url: '',
        country: 'United States',
        operator: Operators.USSF,
    }),
    MITMIL: new DetailedSensor({
        objName: 'MITMIL',
        shortName: 'MIL',
        id: 0,
        name: 'Westford, Massachusetts',
        uiName: 'Westford',
        system: 'Millstone',
        type: SpaceObjectType.MECHANICAL,
        lat: 42.6233,
        lon: -71.4882,
        alt: 0.131,
        minAz: 0,
        maxAz: 360,
        minEl: 1,
        maxEl: 90,
        minRng: 200,
        maxRng: 50000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: 'https://mostlymissiledefense.com/2012/05/05/space-surveillance-sensors-millstone-hill-radar/',
        country: 'United States',
        operator: Operators.MIT,
    }),
    GEODDSDGC: new DetailedSensor({
        objName: 'GEODDSDGC',
        id: 0,
        name: 'Diego Garcia',
        uiName: 'Diego Garcia',
        system: 'GEODSS',
        type: SpaceObjectType.OPTICAL,
        lat: -7.29648,
        lon: 72.390153,
        alt: 0.0,
        minAz: 0,
        maxAz: 360,
        minEl: 20, // https://www.osti.gov/servlets/purl/1253293
        maxEl: 90,
        minRng: 0,
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: 'https://mostlymissiledefense.com/2012/08/20/space-surveillance-sensors-geodss-ground-based-electro-optical-deep-space-surveillance-system-august-20-2012/',
        country: 'United States',
        operator: Operators.USSF,
    }),
    GEODDSMAU: new DetailedSensor({
        objName: 'GEODDSMAU',
        id: 0,
        name: 'Maui, Hawaii',
        uiName: 'Maui',
        system: 'GEODSS',
        type: SpaceObjectType.OPTICAL,
        lat: 20.70835,
        lon: -156.257595,
        alt: 3.0,
        minAz: 0,
        maxAz: 360,
        minEl: 20, // https://www.osti.gov/servlets/purl/1253293
        maxEl: 90,
        minRng: 0,
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: 'https://mostlymissiledefense.com/2012/08/20/space-surveillance-sensors-geodss-ground-based-electro-optical-deep-space-surveillance-system-august-20-2012/',
        country: 'United States',
        operator: Operators.USSF,
    }),
    GEODDSSOC: new DetailedSensor({
        objName: 'GEODDSSOC',
        id: 0,
        name: 'Socorro, New Mexico',
        uiName: 'Socorro',
        system: 'GEODSS',
        type: SpaceObjectType.OPTICAL,
        lat: 33.817233,
        lon: -106.659961,
        alt: 1.24,
        minAz: 0,
        maxAz: 360,
        minEl: 20, // https://www.osti.gov/servlets/purl/1253293
        maxEl: 90,
        minRng: 0,
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: 'https://mostlymissiledefense.com/2012/08/20/space-surveillance-sensors-geodss-ground-based-electro-optical-deep-space-surveillance-system-august-20-2012/',
        country: 'United States',
        operator: Operators.USSF,
    }),
    RAFASC: new DetailedSensor({
        objName: 'RAFASC',
        shortName: 'ASC',
        id: 0,
        name: 'Ascension Island, United Kingdom',
        uiName: 'RAF Ascension Island',
        system: 'FPQ-15',
        freqBand: 'C-Band',
        type: SpaceObjectType.MECHANICAL,
        lat: -7.969444,
        lon: -14.393889,
        alt: 0.0,
        minAz: 0,
        maxAz: 360,
        minEl: 1,
        maxEl: 90,
        minRng: 200,
        maxRng: 50000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'United States',
        operator: Operators.USSF,
    }),
    GLBII: new DetailedSensor({
        objName: 'GLBII',
        id: 0,
        name: 'Vardø, Norway',
        uiName: 'Vardø',
        system: 'Globus II',
        type: SpaceObjectType.MECHANICAL,
        lat: 70.3671,
        lon: 31.1271,
        alt: 0.0,
        minAz: 0,
        maxAz: 360,
        minEl: 1,
        maxEl: 90,
        minRng: 200,
        maxRng: 50000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Norway',
        operator: Operators.NOR,
    }),
    HOLCBAND: new DetailedSensor({
        objName: 'HOLCBAND',
        id: 0,
        name: 'Holt Naval Communication Station, Australia',
        uiName: 'Holt Naval CS (C-Band)',
        system: 'C-Band',
        freqBand: 'C-Band',
        type: SpaceObjectType.MECHANICAL,
        lat: -21.885698,
        lon: 114.129610,
        alt: 0.0,
        minAz: 0,
        maxAz: 360,
        minEl: 1,
        maxEl: 90,
        minRng: 200,
        maxRng: 40000, // Notional - at least 35,000 km
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Australia',
        operator: Operators.RAAF,
    }),
    HOLSST: new DetailedSensor({
        objName: 'HOLSST',
        id: 0,
        name: 'Holt Naval Communication Station, Australia',
        uiName: 'Holt Naval CS (SST)',
        system: 'SST',
        type: SpaceObjectType.OPTICAL,
        lat: -21.89570189077393,
        lon: 114.08984003031517,
        alt: 0.04572, // https://www.osti.gov/servlets/purl/1253293
        minAz: 0,
        maxAz: 360,
        minEl: 20, // https://amostech.com/TechnicalPapers/2015/SSA/Graham.pdf
        maxEl: 90,
        minRng: 15000,
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Australia',
        operator: Operators.RAAF,
    }),
    // HOLDARC
    HOLDARC: new DetailedSensor({
        objName: 'HOLDARC',
        id: 0,
        name: 'Holt Naval Communication Station, Australia',
        uiName: 'Holt Naval CS (DARC)',
        system: 'Deep Space Advanced Radar Capability',
        freqBand: 'X-Band',
        type: SpaceObjectType.MECHANICAL,
        lat: -21.884,
        lon: 114.12,
        alt: 0.0,
        minAz: 0,
        maxAz: 360,
        minEl: 1,
        maxEl: 90,
        minRng: 200,
        maxRng: 40000, // Notional - at least 35,000 km
        zoom: ZoomValue.GEO,
        changeObjectInterval: 1000,
        url: '',
        country: 'Australia',
        operator: Operators.RAAF,
    }),
    // LRDR
    LRDR: new RfSensor({
        objName: 'LRDR',
        id: 0,
        name: 'Long Range Discrimination Radar, Alaska',
        uiName: 'Clear AFS (LRDR)',
        system: 'LRDR',
        freqBand: 'S-Band',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 64.290556,
        lon: -149.186945,
        alt: 0.175, // Open Street Maps
        minAz: 184,
        maxAz: 64,
        boresightAz: [244, 4],
        minEl: 3,
        maxEl: 85,
        boresightEl: [20, 20],
        minRng: 200,
        maxRng: 12500, // https://www.janes.com/osint-insights/defence-news/c4isr/lockheed-martin-delivers-spy-7-radar-to-japan
        beamwidth: 0.3, // Roough estimate - need a source
        zoom: ZoomValue.GEO,
        changeObjectInterval: 1000,
        url: '',
        country: 'United States',
        operator: Operators.USSF,
    }),
    // TPY-2 RADARS
    HARTPY: new DetailedSensor({
        objName: 'HARTPY',
        id: 0,
        name: 'Har Keren TPY-2, Israel',
        uiName: 'Har Keren',
        system: 'TPY-2',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 30.995807,
        lon: 34.496062,
        alt: 0.173,
        minAz: 5,
        maxAz: 125,
        minEl: 5,
        maxEl: 90,
        /*
         * TODO: incorporate boresight into rae2ecf calculations for inclined sensors
         * maxEl: <Degrees>95,
         */
        minRng: 0,
        maxRng: 3000, // https://missilethreat.csis.org/defsys/tpy-2/
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        url: '',
        country: 'United States',
        operator: Operators.USA,
    }),
    QTRTPY: new DetailedSensor({
        objName: 'QTRTPY',
        id: 0,
        name: 'Al Udeid, Qatar',
        uiName: 'Al Udeid',
        system: 'TPY-2',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 25.31598,
        lon: 51.146515,
        alt: 0.01,
        minAz: 335,
        maxAz: 95,
        minEl: 0,
        maxEl: 90,
        minRng: 0,
        maxRng: 3000, // https://missilethreat.csis.org/defsys/tpy-2/
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        url: '',
        country: 'United States',
        operator: Operators.USA,
    }),
    KURTPY: new DetailedSensor({
        objName: 'KURTPY',
        id: 0,
        name: 'Kürecik Radar Station, Turkey',
        uiName: 'Kürecik',
        system: 'TPY-2',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 38.349444,
        lon: 37.793611,
        alt: 1.969,
        minAz: 40,
        maxAz: 160,
        minEl: 0,
        maxEl: 90,
        minRng: 0,
        maxRng: 3000, // https://missilethreat.csis.org/defsys/tpy-2/
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        url: '',
        country: 'United States',
        operator: Operators.USA,
    }),
    SHATPY: new DetailedSensor({
        objName: 'SHATPY',
        id: 0,
        name: 'Shariki Communication Site, Japan',
        uiName: 'Shariki',
        system: 'TPY-2',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 40.88809,
        lon: 140.337698,
        alt: 0.01,
        minAz: 230,
        maxAz: 350,
        minEl: 0,
        maxEl: 90,
        minRng: 0,
        maxRng: 3000, // https://missilethreat.csis.org/defsys/tpy-2/
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        url: '',
        country: 'United States',
        operator: Operators.USA,
    }),
    KCSTPY: new DetailedSensor({
        objName: 'KCSTPY',
        id: 0,
        name: 'Kyogamisaki Communication Site, Japan',
        uiName: 'Kyogamisaki',
        system: 'TPY-2',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 35.766667,
        lon: 135.195278,
        alt: 0.01,
        minAz: 210,
        maxAz: 330,
        minEl: 0,
        maxEl: 90,
        minRng: 0,
        maxRng: 3000, // https://missilethreat.csis.org/defsys/tpy-2/
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        url: '',
        country: 'United States',
        operator: Operators.USA,
    }),
    SBXRDR: new DetailedSensor({
        objName: 'SBXRDR',
        id: 0,
        name: 'Sea-Based X-Band Radar, Pacific Ocean',
        uiName: 'Mobile (Ocean)',
        system: 'SBX',
        freqBand: 'X-Band',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 36.5012,
        lon: 169.6941,
        alt: 0.0,
        minAz: 275,
        maxAz: 300,
        minEl: 0,
        maxEl: 90,
        minRng: 0,
        maxRng: 4025,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        url: '',
        country: 'United States',
        operator: Operators.USA,
    }),
    // LEO LABS
    LEOMSR: new DetailedSensor({
        objName: 'LEOMSR',
        id: 0,
        name: 'Midland Space Radar, Texas',
        uiName: 'Midland Space Radar',
        system: 'UHF',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 31.9643,
        lon: -103.233245,
        alt: 0.855,
        minAz: 70,
        maxAz: 72,
        minEl: 30,
        maxEl: 91, // 91 to ensure visual overlap
        minRng: 100,
        maxRng: 1800,
        minAz2: 250,
        maxAz2: 252,
        minEl2: 30,
        maxEl2: 91, // 91 to ensure visual overlap
        minRng2: 100,
        maxRng2: 1800,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        url: 'https://platform.leolabs.space/sites/msr',
        country: 'United States',
        volume: true,
        operator: Operators.LEOLABS,
    }),
    LEOPFISR: new DetailedSensor({
        objName: 'LEOPFISR',
        id: 0,
        name: 'Poker Flat Incoherent Scatter Radar, Alaska',
        uiName: 'Poker Flat ISR',
        system: 'Incoherent Scatter',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 65.12992,
        lon: -147.47104,
        alt: 0.23,
        minAz: 0,
        maxAz: 360,
        minEl: 45,
        maxEl: 90, // 91 to ensure visual overlap
        minRng: 100,
        maxRng: 1800,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        url: 'https://platform.leolabs.space/sites/pfisr',
        country: 'United States',
        /*
         * "boresight": new DetailedSensor({ "azimuth": 15.0, "elevation": 74.0 }),
         * "transmitFrequency": 450000000.0,
         * "transmitPower": 2000000.0,
         */
        volume: true,
        operator: Operators.LEOLABS,
    }),
    /*
     * TODO: There needs to be a new method for doing FOV when
     * the radar is a fence but not aiming at 90 elevation
     */
    LEOKSR: new DetailedSensor({
        objName: 'LEOKSR',
        id: 0,
        name: 'Kiwi Space Radar, New Zealand',
        uiName: 'Kiwi Space Radar',
        system: 'S-Band',
        freqBand: 'S-Band',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: -45.03854,
        lon: 170.09556,
        alt: 0.6,
        /*
         * minAz:<Degrees>(-13 - 45),
         * maxAz: <Degrees>(-13 + 45),
         * minEl: <Degrees>69,
         * maxEl: <Degrees>71,
         * minRng: <Kilometers>100,
         * maxRng: <Kilometers>1800,
         * minAz2: <Degrees>(167 - 45),
         * maxAz2: <Degrees>(167 + 45),
         * minEl2: <Degrees>69,
         * maxEl2: <Degrees>71,
         * minRng2: <Kilometers>100,
         * maxRng2: <Kilometers>1800,
         */
        minAz: 269,
        maxAz: 271,
        minEl: 10,
        maxEl: 170,
        minRng: 100,
        maxRng: 3000,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        url: 'https://platform.leolabs.space/sites/ksr',
        country: 'United States',
        volume: true,
        operator: Operators.LEOLABS,
    }),
    LEOCRSR: new DetailedSensor({
        objName: 'LEOCRSR',
        id: 0,
        name: 'Costa Rica Space Radar, Costa Rica',
        uiName: 'Costa Rica SR',
        system: 'S-Band',
        freqBand: 'S-Band',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 10.611782670733335, // https://www.radartutorial.eu/19.kartei/02.surv/karte087.en.html
        lon: -85.52869380341954,
        alt: 0.0,
        minAz: 209,
        maxAz: 211,
        minEl: 20,
        maxEl: 180, // NOTE: Not sure why this looks correct, but 200 goes into the earth
        minRng: 100,
        maxRng: 3000,
        minAz2: 119,
        maxAz2: 121,
        minEl2: 20,
        maxEl2: 180, // NOTE: Not sure why this looks correct, but 200 goes into the earth
        minRng2: 100,
        maxRng2: 3000,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        url: 'https://platform.leolabs.space/sites/crsr',
        country: 'United States',
        volume: true,
        operator: Operators.LEOLABS,
    }),
    LEOAZORES: new DetailedSensor({
        objName: 'LEOAZORES',
        id: 0,
        name: 'Azores Space Radar, Azores',
        uiName: 'Azores Space Radar',
        system: 'S-Band',
        freqBand: 'S-Band',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 36.9975,
        lon: -25.1384933,
        alt: 0.198,
        minAz: 209,
        maxAz: 211,
        minEl: 20,
        maxEl: 180, // NOTE: Not sure why this looks correct, but 200 goes into the earth
        minRng: 100,
        maxRng: 3000,
        minAz2: 119,
        maxAz2: 121,
        minEl2: 20,
        maxEl2: 180, // NOTE: Not sure why this looks correct, but 200 goes into the earth
        minRng2: 100,
        maxRng2: 3000,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        url: 'https://platform.leolabs.space/sites/crsr',
        country: 'United States',
        volume: true,
        operator: Operators.LEOLABS,
    }),
    LEOWASR: new DetailedSensor({
        objName: 'LEOWASR',
        id: 0,
        name: 'Western Australia Space Radar, Australia',
        uiName: 'Western Australia Space Radar',
        system: 'S-Band',
        freqBand: 'S-Band',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: -33.308487,
        lon: 116.030608,
        alt: 0.241,
        minAz: 119,
        maxAz: 121,
        minEl: 10,
        maxEl: 170, // NOTE: Not sure why this looks correct, but 200 goes into the earth
        minRng: 100,
        maxRng: 3000,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        url: 'https://platform.leolabs.space/sites/crsr',
        country: 'United States',
        volume: true,
        operator: Operators.LEOLABS,
    }),
    // LEO LABS ARSR on hold as of 2023-11-12 due to national security concerns from Argentina
    // ESOC RADARS
    GRV: new DetailedSensor({
        objName: 'GRV',
        id: 0,
        name: 'Grand Réseau Adapté à la Veille Spatiale, France',
        uiName: 'Dijon',
        system: 'GRAVES',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 47.347778,
        lon: 5.51638,
        alt: 0.0,
        minAz: 90,
        maxAz: 270,
        minEl: 20,
        maxEl: 40,
        minRng: 0,
        maxRng: 1700, // http://emits.sso.esa.int/emits-doc/AO5059RD1.pdf
        zoom: ZoomValue.LEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'France',
        volume: true,
        operator: Operators.ESA,
    }),
    TIR: new DetailedSensor({
        objName: 'TIR',
        id: 0,
        name: 'Wachtberg, Germany',
        uiName: 'Wachtberg',
        system: 'TIRA',
        freqBand: 'L/Ku-Band',
        type: SpaceObjectType.MECHANICAL,
        lat: 50.6166,
        lon: 7.1296,
        alt: 0.0,
        minAz: 0,
        maxAz: 360,
        minEl: 1.5, // http://www.issfd.org/ISSFD_2012/ISSFD23_CRSD2_3.pdf
        maxEl: 90,
        minRng: 0,
        maxRng: 2000, // http://emits.sso.esa.int/emits-doc/AO5059RD1.pdf
        zoom: ZoomValue.LEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Germany',
        operator: Operators.ESA,
    }),
    GES: new DetailedSensor({
        objName: 'GES',
        id: 0,
        name: 'Schmidtenhöhe, Germany',
        uiName: 'Schmidtenhöhe',
        system: 'GESTRA',
        freqBand: 'L-Band',
        type: SpaceObjectType.MECHANICAL,
        lat: 50.335711,
        lon: 7.6359085,
        alt: 0.0,
        minAz: 0,
        maxAz: 360,
        minEl: 1.5,
        maxEl: 90,
        minRng: 0,
        maxRng: 3000,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Germany',
        operator: Operators.ESA,
    }),
    NRC: new DetailedSensor({
        objName: 'NRC',
        id: 0,
        name: 'Northern Cross Radiotelescope, Italy',
        uiName: 'Medicina',
        system: 'BIRALES',
        freqBand: 'UHF',
        type: SpaceObjectType.BISTATIC_RADIO_TELESCOPE,
        lat: 44.5208,
        lon: 11.6469,
        alt: 0.025,
        minAz: 89.1,
        maxAz: 90.9,
        minEl: 45,
        maxEl: 90,
        minRng: 0,
        maxRng: 1700,
        minAz2: 179.1,
        maxAz2: 180.9,
        minEl2: 45,
        maxEl2: 90,
        minRng2: 0,
        maxRng2: 1700,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Italy',
        operator: Operators.ESA,
    }),
    PDM: new DetailedSensor({
        objName: 'PDM',
        id: 0,
        name: 'Pratica di Mare Air Base, Italy',
        uiName: 'Pratica di Mare',
        system: 'MiTE',
        type: SpaceObjectType.OPTICAL,
        lat: 41.654444, // https://en.wikipedia.org/wiki/Pratica_di_Mare_Air_Base
        lon: 12.445,
        alt: 0.0,
        minAz: 0,
        maxAz: 360,
        minEl: 5, // 0 seems low - https://amostech.com/TechnicalPapers/2015/Adaptive_Optics_Imaging/DelGenio.pdf
        maxEl: 90,
        minRng: 0, // https://amostech.com/TechnicalPapers/2015/Adaptive_Optics_Imaging/DelGenio.pdf
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Italy',
        operator: Operators.ITAF,
    }),
    TRO: new DetailedSensor({
        objName: 'TRO',
        id: 0,
        name: 'Royal Air Force Troödos, Cyprus',
        uiName: 'Royal Air Force Troödos',
        system: 'Starbrook',
        type: SpaceObjectType.OPTICAL,
        lat: 34.912778,
        lon: 32.883889,
        alt: 0,
        minAz: 0,
        maxAz: 360,
        minEl: 3,
        maxEl: 90,
        minRng: 15000,
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'United Kingdom',
        operator: Operators.UKSA,
    }),
    SDT: new DetailedSensor({
        objName: 'SDT',
        id: 0,
        name: 'ESA Space Debris Telescope, Spain',
        uiName: 'Tenerife',
        system: 'SDT',
        type: SpaceObjectType.OPTICAL,
        lat: 28.3,
        lon: -16.5097,
        alt: 0,
        minAz: 0,
        maxAz: 360,
        minEl: 10,
        maxEl: 90,
        minRng: 15000,
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Spain',
        operator: Operators.ESA,
    }),
    ZimLAT: new DetailedSensor({
        objName: 'ZimLAT',
        id: 0,
        name: 'Zimmerwald Observatory, Switzerland',
        uiName: 'Zimmerwald',
        system: 'ZimLAT',
        type: SpaceObjectType.OPTICAL,
        lat: 46.877225,
        lon: 7.465225,
        alt: 0,
        minAz: 0,
        maxAz: 360,
        minEl: 10,
        maxEl: 90,
        minRng: 15000,
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Switzerland',
        operator: Operators.ESA,
    }),
    ZimSMART: new DetailedSensor({
        objName: 'ZimSMART',
        id: 0,
        name: 'Zimmerwald Observatory, Switzerland',
        uiName: 'Zimmerwald',
        system: 'ZimSMART',
        type: SpaceObjectType.OPTICAL,
        lat: 46.876947,
        lon: 7.465086,
        alt: 0,
        minAz: 0,
        maxAz: 360,
        minEl: 10,
        maxEl: 90,
        minRng: 15000,
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Switzerland',
        operator: Operators.ESA,
    }),
    Tromso: new DetailedSensor({
        objName: 'Tromso',
        id: 0,
        name: 'Tromso, Norway',
        uiName: 'Tromso',
        system: 'Incoherent Scatter',
        freqBand: 'UHF/VHF',
        type: SpaceObjectType.BISTATIC_RADIO_TELESCOPE,
        lat: 69.586439,
        lon: 19.226111,
        alt: 0,
        minAz: 0,
        maxAz: 360,
        minEl: 30, // https://www.eiscat.se/groups/Operations/ops-manual/ops-manual.htm
        maxEl: 90,
        minRng: 500,
        maxRng: 1500,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Norway',
        operator: Operators.EISCAT,
    }),
    Kiruna: new DetailedSensor({
        objName: 'Kiruna',
        id: 0,
        name: 'Kiruna, Sweden',
        uiName: 'Kiruna',
        system: 'Incoherent Scatter',
        freqBand: 'UHF/VHF',
        type: SpaceObjectType.BISTATIC_RADIO_TELESCOPE,
        lat: 67.860778,
        lon: 20.433806,
        alt: 0,
        minAz: 0,
        maxAz: 360,
        minEl: 10,
        maxEl: 90,
        minRng: 500,
        maxRng: 1500,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Sweden',
        operator: Operators.EISCAT,
    }),
    Sodankyla: new DetailedSensor({
        objName: 'Sodankyla',
        id: 0,
        name: 'Sodankyla, Finland',
        uiName: 'Sodankyla',
        system: 'Incoherent Scatter',
        freqBand: 'UHF/VHF',
        type: SpaceObjectType.BISTATIC_RADIO_TELESCOPE,
        lat: 67.363903,
        lon: 26.630417,
        alt: 0,
        minAz: 0,
        maxAz: 360,
        minEl: 10,
        maxEl: 90,
        minRng: 500,
        maxRng: 1500,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Finland',
        operator: Operators.EISCAT,
    }),
    Svalbard: new DetailedSensor({
        objName: 'Svalbard',
        id: 0,
        name: 'Svalbard, Norway',
        uiName: 'Svalbard',
        system: 'Incoherent Scatter',
        freqBand: 'UHF/VHF',
        type: SpaceObjectType.BISTATIC_RADIO_TELESCOPE,
        lat: 78.152669,
        lon: 16.058706,
        alt: 0,
        minAz: 0,
        maxAz: 360,
        minEl: 10,
        maxEl: 90,
        minRng: 500,
        maxRng: 1500,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Norway',
        operator: Operators.EISCAT,
    }),
    // RUSSIAN RADARS
    OLED: new DetailedSensor({
        objName: 'OLED',
        id: 0,
        name: 'Olenegorsk, Russia',
        uiName: 'Olenegorsk',
        system: 'Dnepr',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 68.1141,
        lon: 33.9102,
        alt: 0.0,
        minAz: 280, // All Information via russianforces.org
        maxAz: 340,
        minEl: 5.5,
        maxEl: 34.5,
        minRng: 250,
        maxRng: 4600,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        country: 'Russia',
        operator: Operators.RUSSF,
    }),
    OLEV: new DetailedSensor({
        objName: 'OLEV',
        id: 0,
        name: 'Olenegorsk, Russia',
        uiName: 'Olenegorsk',
        system: 'Voronezh-VP', // AKA Voronezh-M
        freqBand: 'VHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 68.090694,
        lon: 34.327539,
        alt: 0.0,
        minAz: 250, // All Information via russianforces.org
        maxAz: 10,
        minEl: 7,
        maxEl: 70,
        minRng: 250,
        maxRng: 6000, // 6000 horizontal, 10000 vertical
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        country: 'Russia',
        operator: Operators.RUSSF,
        // Under Contstruction
    }),
    PEC: new DetailedSensor({
        objName: 'PEC',
        id: 0,
        name: 'Pechora, Russia',
        uiName: 'Pechora',
        system: 'Dar\'yal',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 65.21,
        lon: 57.295,
        alt: 0.0,
        minAz: 305, // All Information via russianforces.org
        maxAz: 55,
        minEl: 2,
        maxEl: 55,
        minRng: 300,
        maxRng: 7200,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        country: 'Russia',
        operator: Operators.RUSSF,
    }),
    // Vorkuta
    MISD: new DetailedSensor({
        objName: 'MISD',
        id: 0,
        name: 'Mishelevka, Russia',
        uiName: 'Mishelevka',
        system: 'Dnepr',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 52.8555,
        lon: 103.2317,
        alt: 0.0,
        minAz: 41, // All Information via russianforces.org
        maxAz: 219,
        minEl: 5.5,
        maxEl: 34.5,
        minRng: 250,
        maxRng: 4600,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        country: 'Russia',
        operator: Operators.RUSSF,
    }),
    MISV: new DetailedSensor({
        // NOTE: There are two co-located here
        objName: 'MISV',
        id: 0,
        name: 'Mishelevka, Russia',
        uiName: 'Mishelevka',
        system: 'Voronezh-VP', // AKA Voronezh-M or Voronezh-SM
        freqBand: 'VHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 52.8555,
        lon: 103.2317,
        alt: 0.0,
        // boresight 130
        minAz: 10, // All Information via russianforces.org
        maxAz: 250,
        minEl: 2,
        maxEl: 70,
        minRng: 250,
        maxRng: 6000, // 6000 horizontal, 10000 vertical
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        country: 'Russia',
        operator: Operators.RUSSF,
    }),
    LEKV: new DetailedSensor({
        objName: 'LEKV',
        id: 0,
        name: 'Lekhtusi, Russia',
        uiName: 'Lekhtusi',
        system: 'Voronezh-M',
        freqBand: 'VHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 60.275458,
        lon: 30.546017,
        alt: 0.0,
        minAz: 245,
        maxAz: 355,
        minEl: 2,
        maxEl: 70,
        minRng: 250,
        maxRng: 6000,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        country: 'Russia',
        operator: Operators.RUSSF,
    }),
    // Planned Voronezh-SM (Ragozinka-2)
    ARMV: new DetailedSensor({
        objName: 'ARMV',
        id: 0,
        name: 'Armavir, Russia',
        uiName: 'Armavir',
        system: 'Voronezh-DM',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 44.925106,
        lon: 40.983894,
        alt: 0.0,
        // 2 Radars = 240az
        minAz: 55, // All Information via russianforces.org
        maxAz: 295,
        minEl: 2,
        maxEl: 70,
        minRng: 250,
        maxRng: 6000,
        changeObjectInterval: 1000,
        country: 'Russia',
        zoom: ZoomValue.LEO,
        operator: Operators.RUSSF,
    }),
    /*
     * Decommissioned???
     * GAN: new DetailedSensor({
     *   objName: 'GAN',
     *   id: 0,
     *   name: 'Gantsevichi, Russia',
     *   uiName: 'GAN',
     *   system: 'GAN',
     *   type: SpaceObjectType.PHASED_ARRAY_RADAR,
     *   lat: <Degrees>52.85,
     *   lon: <Degrees>26.48,
     *   alt: <Kilometers>0.0,
     *   minAz:<Degrees>190, // All Information via russianforces.org
     *   maxAz: <Degrees>310,
     *   minEl: <Degrees>3,
     *   maxEl: <Degrees>80,
     *   minRng: <Kilometers>300,
     *   maxRng: <Kilometers>6500,
     *   zoom: ZoomValue.LEO,
     *   changeObjectInterval: <Milliseconds>1000,
     *   country: 'Russia',
     *   operator: Operators.RUSSF,
     * }),
     */
    KALV: new DetailedSensor({
        objName: 'KALV',
        id: 0,
        name: 'Kaliningrad, Russia', // Pionersky/Kaliningrad
        uiName: 'Kaliningrad',
        system: 'Voronezh-DM', // AKA Voronezh-M
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 54.857294,
        lon: 20.18235,
        alt: 0.0,
        // boresight 240
        minAz: 180, // All Information via russianforces.org
        maxAz: 300,
        minEl: 2,
        maxEl: 70,
        minRng: 250,
        maxRng: 6000,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        country: 'Russia',
        operator: Operators.RUSSF,
    }),
    BARV: new DetailedSensor({
        objName: 'BARV',
        id: 0,
        name: 'Barnaul, Russia',
        uiName: 'Barnaul',
        system: 'Voronezh-DM', // AKA Voronezh-M
        freqBand: 'VHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 53.139194,
        lon: 83.68125,
        alt: 0.0,
        minAz: 110, // All Information via russianforces.org
        maxAz: 230,
        minEl: 2,
        maxEl: 70,
        minRng: 250,
        maxRng: 6000,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        country: 'Russia',
        operator: Operators.RUSSF,
    }),
    YENV: new DetailedSensor({
        objName: 'YENV',
        id: 0,
        name: 'Yeniseysk, Russia',
        uiName: 'Yeniseysk',
        system: 'Voronezh-DM', // AKA Voronezh-M
        freqBand: 'VHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 58.506095,
        lon: 92.046072,
        alt: 0.0,
        // boresight 240
        minAz: 330, // All Information via russianforces.org
        maxAz: 90,
        minEl: 2,
        maxEl: 70,
        minRng: 250,
        maxRng: 6000,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        country: 'Russia',
        operator: Operators.RUSSF,
    }),
    ORSV: new DetailedSensor({
        objName: 'ORSV',
        id: 0,
        name: 'Orsk, Russia',
        uiName: 'Orsk',
        system: 'Voronezh-M',
        freqBand: 'UHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 51.273346,
        lon: 58.95903,
        alt: 0.0,
        // boresight 180 - https://www.janes.com/images/default-source/news-images/bsp_13855-idr-16436.jpg?sfvrsn=aa8c7163_2
        minAz: 120, // All Information via russianforces.org
        maxAz: 240,
        minEl: 2,
        maxEl: 70,
        minRng: 250,
        maxRng: 6000,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        country: 'Russia',
        operator: Operators.RUSSF,
    }),
    /*
     * Removed from combat alert in 2020
     * BAL: new DetailedSensor({
     *   objName: 'BAL',
     *   id: 0,
     *   name: 'Balkhash, Russia',
     *   uiName: 'BAL',
     *   system: 'Dnepr',
     *   freqBand: 'UHF',
     *   type: SpaceObjectType.PHASED_ARRAY_RADAR,
     *   lat: <Degrees>46.603076,
     *   lon: <Degrees>74.530985,
     *   alt: <Kilometers>0.0,
     *   minAz:<Degrees>91, // All Information via russianforces.org
     *   maxAz: <Degrees>151,
     *   minEl: <Degrees>5.5,
     *   maxEl: <Degrees>34.5,
     *   minRng: <Kilometers>385,
     *   maxRng: <Kilometers>4600,
     *   zoom: ZoomValue.LEO,
     *   changeObjectInterval: <Milliseconds>1000,
     *   country: 'Russia',
     *   operator: Operators.RUSSF,
     * }),
     */
    STO: new DetailedSensor({
        objName: 'STO',
        id: 0,
        name: 'Storozhevaya, Russia',
        uiName: 'Storozhevaya',
        system: 'Krona',
        freqBand: 'UHF/VHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR, // Actually two sites and the other is a telescope/LIDAR combo
        lat: 43.718331,
        lon: 41.226253,
        alt: 2.115,
        minAz: 0,
        maxAz: 360,
        minEl: 5,
        maxEl: 90,
        minRng: 0,
        maxRng: 50000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        country: 'Russia',
        operator: Operators.RUSSF,
    }),
    NAK: new DetailedSensor({
        objName: 'NAK',
        id: 0,
        name: 'Nakhodka, Russia',
        uiName: 'Nakhodka',
        system: 'Krona-N', // crown of a tree (because of the antenna shape)
        freqBand: 'UHF/VHF',
        type: SpaceObjectType.PHASED_ARRAY_RADAR, // 1xUHF & 5xSHF radar
        lat: 42.9357,
        lon: 132.576769,
        alt: 0.21,
        minAz: 0,
        maxAz: 360,
        minEl: 2,
        maxEl: 90,
        minRng: 0,
        maxRng: 50000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        country: 'Russia',
        operator: Operators.RUSSF,
    }),
    // eslint-disable-next-line multiline-comment-style
    // CHINESE RADARS
    // XUA: new DetailedSensor({ // Not operational anymore
    //   id: 0,
    //   name: 'Xuanhua, China',
    //   shortName: 'XUA',
    //   type: SpaceObjectType.PHASED_ARRAY_RADAR,
    //   lat: <Degrees>40.446944,
    //   lon: <Degrees>115.116389,
    //   alt: <Kilometers>1.6,
    //   minAz:<Degrees>300, // Information via global ssa sensors amos 2010.pdf (sinodefence.com/special/airdefense/project640.asp)
    //   maxAz: <Degrees>60, // Information via global ssa sensors amos 2010.pdf (sinodefence.com/special/airdefense/project640.asp)
    //   minEl: <Degrees>2, // Information via globalsecurity.org
    //   maxEl: <Degrees>80, // Information via globalsecurity.org
    //   minRng: <Kilometers>300,
    //   maxRng: <Kilometers>3000, // Information via global ssa sensors amos 2010.pdf (sinodefence.com/special/airdefense/project640.asp)
    //   zoom: ZoomValue.LEO,
    //   changeObjectInterval: <Milliseconds>1000,
    //   country: 'China',
    //
    //
    // }),
    XIN: new DetailedSensor({
        objName: 'XIN',
        id: 0,
        name: 'Korla Site Xingjiang, China', // Korla
        uiName: 'Korla',
        system: 'LPAR',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 41.64131987863126, // https://hfasia.blogspot.com/2017/02/blog-post_50.html
        lon: 86.23695312232473,
        alt: 0.993, // https://www.freemaptools.com/elevation-finder.htm
        minAz: 0, // https://www.globalsecurity.org/space/world/china/images/xinjiang-radar-image-2018-1-s.jpg
        maxAz: 360, // It is on a rotatable platform
        minEl: 3, // Assumed same characteristics as AN/FPS-115
        maxEl: 85,
        minRng: 200, // Assumed same characteristics as AN/FPS-115
        maxRng: 5556, // Assumed same characteristics as AN/FPS-115
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        country: 'China',
        operator: Operators.PLA,
    }),
    HEI: new DetailedSensor({
        objName: 'HEI',
        id: 0,
        name: 'Huanan Heilongjiang, China',
        uiName: 'Huanan',
        system: 'LPAR',
        freqBand: 'X-Band',
        type: SpaceObjectType.PHASED_ARRAY_RADAR, // https://www.globalsecurity.org/wmd/world/china/lpar-x.htm
        lat: 46.528164,
        lon: 130.755235,
        alt: 0.241, // https://www.freemaptools.com/elevation-finder.htm
        minAz: 135, // X-Band https://www.globalsecurity.org/wmd/world/china/lpar-x.htm
        maxAz: 225, // Assumed +/- 45 degrees
        minEl: 3,
        maxEl: 65,
        minRng: 200,
        maxRng: 3000,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        country: 'China',
        operator: Operators.PLA,
    }),
    ZHE: new DetailedSensor({
        objName: 'ZHE',
        id: 0,
        name: 'Lin\'an Zhejiang, China',
        uiName: 'Lin\'an',
        system: 'LPAR',
        freqBand: 'X-Band',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 30.28661248844618, // https://hfasia.blogspot.com/2017/02/blog-post_50.html
        lon: 119.12859385017512,
        alt: 1.342, // https://www.freemaptools.com/elevation-finder.htm
        minAz: 60,
        maxAz: 300,
        minEl: 2,
        maxEl: 80,
        minRng: 300,
        maxRng: 3000,
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        country: 'China',
        operator: Operators.PLA,
    }),
    SHD: new DetailedSensor({
        objName: 'SHD',
        id: 0,
        name: 'Shandong, China', // P-Band (225 Mhz - 390 Mhz)
        uiName: 'Shandong',
        system: 'LPAR',
        freqBand: 'P-Band',
        type: SpaceObjectType.PHASED_ARRAY_RADAR, // https://www.globalsecurity.org/wmd/world/china/lpar-p.htm
        lat: 36.023072,
        lon: 118.093115,
        alt: 0.694, // https://www.freemaptools.com/elevation-finder.htm
        minAz: 343.9, // Two Faces Boresight ~163.9 and ~103.9 degrees
        // https://www.omnicalculator.com/other/azimuth (163.9 degrees if aimed at Taipei)
        maxAz: 223.9, // https://www.defensenews.com/global/asia-pacific/2022/04/18/new-chinese-radar-looks-towards-japan-satellite-image-shows/
        minEl: 3,
        maxEl: 85,
        minRng: 200,
        maxRng: 5500, // ~10,000 Transceivers
        zoom: ZoomValue.LEO,
        changeObjectInterval: 1000,
        country: 'China',
        operator: Operators.PLA,
    }),
    PMO: new DetailedSensor({
        objName: 'PMO',
        id: 0,
        name: 'Purple Mountain Observatory, China',
        uiName: 'Nanjing',
        system: '60-cm Zeiss Telescope',
        type: SpaceObjectType.OPTICAL,
        lat: 32.064946,
        lon: 118.829677,
        alt: 0.267,
        minAz: 0,
        maxAz: 360,
        minEl: 10,
        maxEl: 90,
        minRng: 15000,
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        country: 'China',
        operator: Operators.CAS,
    }),
    // OTHER SENSORS
    MLS: new DetailedSensor({
        objName: 'MLS',
        id: 0,
        name: 'Mount Lemmon Survey, Arizona',
        uiName: 'Tucson',
        system: '1.52 m Telescope',
        type: SpaceObjectType.OPTICAL,
        lat: 32.442,
        lon: -110.789,
        alt: 2.791,
        minAz: 0,
        maxAz: 360,
        minEl: 10,
        maxEl: 90,
        minRng: 15000,
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        country: 'United States',
        operator: Operators.COMMERCIAL,
    }),
    PO: new DetailedSensor({
        objName: 'PO',
        id: 0,
        name: 'Palomar Mountain Observatory, California',
        uiName: 'Palomar Observatory',
        system: 'Hale Telescope',
        type: SpaceObjectType.OPTICAL,
        lat: 33.3564,
        lon: -116.865,
        alt: 1.712,
        minAz: 0,
        maxAz: 360,
        minEl: 10,
        maxEl: 90,
        minRng: 15000,
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        country: 'United States',
        operator: Operators.CALTECH,
    }),
    LSO: new DetailedSensor({
        objName: 'LSO',
        id: 0,
        name: 'La Sagra Observatory, Spain',
        uiName: 'La Sagra',
        system: '4x Telescopes',
        type: SpaceObjectType.OPTICAL,
        lat: 37.9839,
        lon: -2.5644,
        alt: 0,
        minAz: 0,
        maxAz: 360,
        minEl: 10,
        maxEl: 90,
        minRng: 15000,
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        country: 'Spain',
        operator: Operators.ESA,
    }),
    // ISON Sensors
    MAY: new DetailedSensor({
        objName: 'MAY',
        id: 0,
        name: 'Remote Astronomical Society Observatory, New Mexico',
        uiName: 'Mayhill',
        system: 'MPC H06 Telescope',
        type: SpaceObjectType.OPTICAL,
        lat: 32.9039,
        lon: -105.5289,
        alt: 2.225,
        minAz: 0,
        maxAz: 360,
        minEl: 10,
        maxEl: 90,
        minRng: 15000,
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        country: 'United States',
        operator: Operators.COMMERCIAL,
    }),
    ROC: new DetailedSensor({
        objName: 'ROC',
        id: 0,
        name: 'Leshan , Republic of China (Taiwan)',
        uiName: 'Leshan',
        system: 'AN/FPS-115 (SRP)',
        type: SpaceObjectType.PHASED_ARRAY_RADAR,
        lat: 24.499,
        lon: 121.072,
        alt: 2.6, // https://taiwanenglishnews.com/tag/leshan-radar-station/ (2.6km)
        minAz: 0, // Appears to be 3 faced
        // https://www.google.com/maps/place/24%C2%B029'45.6%22N+121%C2%B004'15.6%22E/@24.4985462,121.0709751,154m/data=!3m1!1e3!4m5!3m4!1s0x0:0xe0073e890dc05d63!8m2!3d24.496!4d121.071
        maxAz: 360,
        minEl: -1, // "Tracks surface ships" https://www.globalsecurity.org/military/world/taiwan/air-defense-over.htm
        maxEl: 85,
        minRng: 200,
        maxRng: 5556,
        changeObjectInterval: 1000,
        zoom: ZoomValue.LEO,
        url: 'https://fas.org/man/eprint/leshan.pdf',
        country: 'Republic of China (Taiwan)',
        operator: Operators.ROC,
    }),
    // Korean OWL-Net
    OWLKorea: new DetailedSensor({
        objName: 'OWLKorea', // City is Daejeon
        id: 0,
        name: 'OWL-Net, Korea',
        uiName: 'OWL-Net Korea',
        system: 'OWL-Net',
        type: SpaceObjectType.OPTICAL,
        lat: 36.397635,
        lon: 127.375679,
        alt: 0.139, // https://koreascience.kr/article/JAKO201535151810320.pdf
        minAz: 0,
        maxAz: 360,
        minEl: 5, // Not sure what the minimum is
        maxEl: 90,
        minRng: 100, // Multiple reports mentioning LEO tracking
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Republic of Korea',
        operator: Operators.OWLNET,
    }),
    OWLMongolia: new DetailedSensor({
        objName: 'OWLMongolia', // City is Songino
        id: 0,
        name: 'OWL-Net, Mongolia',
        uiName: 'OWL-Net Mongolia',
        system: 'OWL-Net',
        type: SpaceObjectType.OPTICAL,
        lat: 47.886111,
        lon: 106.334722,
        alt: 1.674, // https://koreascience.kr/article/JAKO201618241377396.pdf
        minAz: 0,
        maxAz: 360,
        minEl: 5, // Not sure what the minimum is
        maxEl: 90,
        minRng: 100, // Multiple reports mentioning LEO tracking
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Republic of Korea',
        operator: Operators.OWLNET,
    }),
    OWLMorocco: new DetailedSensor({
        objName: 'OWLMorocco', // City is Oukaïmeden
        id: 0,
        name: 'OWL-Net, Morocco',
        uiName: 'OWL-Net Morocco',
        system: 'OWL-Net',
        type: SpaceObjectType.OPTICAL,
        lat: 31.206008082312465,
        lon: -7.866824237940079,
        alt: 2.725, // https://koreascience.kr/article/JAKO201618241377396.pdf
        minAz: 0,
        maxAz: 360,
        minEl: 5, // Not sure what the minimum is
        maxEl: 90,
        minRng: 100, // Multiple reports mentioning LEO tracking
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Republic of Korea',
        operator: Operators.OWLNET,
    }),
    OWLIsrael: new DetailedSensor({
        objName: 'OWLIsrael',
        id: 0,
        name: 'OWL-Net, Israel',
        uiName: 'OWL-Net Israel',
        system: 'OWL-Net',
        type: SpaceObjectType.OPTICAL,
        lat: 30.597389,
        lon: 34.762194,
        alt: 0.8704, // Estimate
        minAz: 0,
        maxAz: 360,
        minEl: 5, // Not sure what the minimum is
        maxEl: 90,
        minRng: 100, // Multiple reports mentioning LEO tracking
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Republic of Korea',
        operator: Operators.OWLNET,
    }),
    OWLUSA: new DetailedSensor({
        objName: 'OWLUSA',
        id: 0,
        name: 'OWL-Net, USA',
        uiName: 'OWL-Net USA',
        system: 'OWL-Net',
        type: SpaceObjectType.OPTICAL,
        lat: 32.44220852576508,
        lon: -110.7892718047087,
        alt: 2.7868, // Estimate
        minAz: 0,
        maxAz: 360,
        minEl: 5, // Not sure what the minimum is
        maxEl: 90,
        minRng: 100, // Multiple reports mentioning LEO tracking
        maxRng: 400000,
        zoom: ZoomValue.GEO,
        changeObjectInterval: 20000,
        url: '',
        country: 'Republic of Korea',
        operator: Operators.OWLNET,
    }),
};
